'use strict';

angular.module('clientDashboardApp.common').service('noteService', function ($q, $http) {
  function NoteService() {
    this.newNote = false;
    this.newNoteItem = null;
    this.deleteTarget = {
      entity:null,
      note:null
    };
  }

  NoteService.prototype.setDeleteTarget = function(entity,note){
    this.deleteTarget.entity = entity;
    this.deleteTarget.note = note;
  }

  NoteService.prototype.resetDeleteTarget = function(){
    this.deleteTarget.entity = null
    this.deleteTarget.note = null;
  }

  NoteService.prototype.getDeleteTarget = function(){
    return this.deleteTarget;
  }

  NoteService.prototype.getNoteState = function() {
    return this.newNote;
  }

  NoteService.prototype.resetNoteState = function() {
    this.newNote = false;
  }

  NoteService.prototype.initNewNote = function(item,type) {
    this.newNote = true;
    this.newNoteItem = item;
  }

  NoteService.prototype.stripHtml = function(str){
    return str.replace(/(<.*\/>|<.*>)+/g,"");
  };

  NoteService.prototype.processAsHtml = function(noteDetail){
    return noteDetail.replace(/(\n)+/g,"<br />");
  };

  NoteService.prototype.processFromHtml = function(noteDetail){
    var tmp;
    tmp = noteDetail.toString();
    tmp = tmp.replace(/(<br \/>)+/g,"\n");
    tmp = tmp.replace(/(<a[^>]*>|<\/a>)+/g,"");
    tmp = NoteService.prototype.stripHtml(tmp);
    return tmp;

  };

  NoteService.prototype.addNote = function (addNoteRequest) {
    var deferred = $q.defer();

    $http
      .post('/dashboard/note', addNoteRequest)
      .success(function (data, status, headers, config) {
        deferred.resolve(data);
      })
      .error(function (data, status, headers, config) {
        deferred.reject('Error occurred while summary!');
      });

    return deferred.promise;
  };

  NoteService.prototype.updateNote = function (note) {
    var deferred = $q.defer();
    note.noteId = note._id;
    $http
      .put('/dashboard/note', note)
      .success(function (data, status, headers, config) {
        deferred.resolve(data);
      })
      .error(function (data, status, headers, config) {
        deferred.reject('Error occurred while summary!');
      });

    return deferred.promise;
  };

  NoteService.prototype.getNotes = function(ids, type, filters = null) {
    // since this gets superspammed by the directive, it might be nice to throttle these
    // requests by aggregating all the individual method calls into a bulk request with multiple promises.
    // invocations would aggregate over short time periods (e.g. ~500ms).
    // Server would have a bulk endpoint that queries notes more efficiently.
    // response would need to include enough details to dispatch promises correctly
    var deferred = $q.defer();
    var params =       {
      ids: ids,
      noteType: type,
      filters
    }
    $http
      .post('/dashboard/note/search', params

    )
      .success(function (data, status, headers, config) {
        deferred.resolve(data);
      })
      .error(function (data, status, headers, config) {
        deferred.reject('Error occurred while summary!');
      });

    return deferred.promise;
  }

  NoteService.prototype.deleteNote = function (noteId) {
    var deferred = $q.defer();

    $http
      .delete('/dashboard/note/' + noteId)
      .success(function (data, status, headers, config) {
        deferred.resolve(data);
      })
      .error(function (data, status, headers, config) {
        deferred.reject('Error occurred while summary!');
      });

    return deferred.promise;
  };

  NoteService.prototype.setNoteVisibilityDefault = function (visibility) {
    var deferred = $q.defer();
    var params = {
      defaultNoteVisibilityLevel: visibility
    }
    $http
      .put('/user/settings', params)
      .success(function (data, status, headers, config) {
        deferred.resolve(data);
      })
      .error(function (data, status, headers, config) {
        deferred.reject('Error occurred while summary!');
      });

    return deferred.promise;
  };

  return new NoteService();

});
